export const SET_BACKDROP = "SET_BACKDROP";

export const setBackdrop = (payload) => ({
	type: SET_BACKDROP,
	payload,
});
